export const COLORS = {
  LONG_CALL: 'var(--color-equities)',
  LONG_PUT: 'var(--off-white)',
  SHORT_CALL: '#197b83',
  CLOUDY_BLUE: 'var(--cloudy-blue)',
  SHORT_PUT: '#999',
};
